import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Sidebar from '../Sidebar'
import Navbar from '../Navbar'
import { Modal, Spinner, ModalBody, ModalHeader, ModalFooter, Button, Input } from 'reactstrap'
import { APIURL } from '../../../constants/common';
import axios from 'axios'
import Pagination from "react-js-pagination";
import dateFormat, { masks } from "dateformat";
import DatePicker from "react-datepicker";

const colourStyles = {

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#B8BCBD" : null,
            color: "grey",
        };
    },
};

export default class Index extends Component {
    constructor() {
        super();
        this.state = {
            token: JSON.parse(localStorage.getItem("token")),
            user: JSON.parse(localStorage.getItem("userData")),
            buyerList: [],
            property_id: "",
            activePage: 1,
            limit: 0,
            totalItemsCount: 0,
            search: "",
            plan: [],
            Loader:false,
            norecord:false,
            selectedDate: "",
            showDate: ""
        }
    }

    handleSelectedDate(e) {
        this.setState({
            showDate: e,
            selectedDate: dateFormat(e, "yyyy-mm-dd"),
            activePage: 1,
        },()=>{
            this.getBuyer()
        })
    }

    clearDate(){
        this.setState({
            showDate: "",
            selectedDate: "",
            activePage: 1,
        },()=>{
            this.getBuyer()
        })
    }

    handleSearch(e) {
        this.setState(
        { search: e.target.value, activePage: 1 }
        , () => { this.getBuyer() });
    }

    handlePlan(e) {
        this.setState(
        {
            plan: e,
            activePage: 1 
        }
        , () => { this.getBuyer() });
    }

    handlePageChange(pageNumber) {
        this.setState(
            { activePage: pageNumber }
            , () => {
                this.getBuyer()
            }
        );
    }

    getBuyer() {
        this.setState({
            Loader:true
        })
        var token = this.state.token
        const formData = new FormData();
        formData.append('page', this.state.activePage);
        formData.append('search', this.state.search);
        formData.append('limit', this.state.limit);

        axios
            .post(APIURL + "sub-user/get-assign-buyer-list-according-to-user", formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then((response) => {
                console.log(response.data.data.data);
                this.setState({
                    buyerList: response.data.data.data,
                    activePage: response.data.data.current_page,
                    totalItemsCount: response.data.data.total,
                    limit: response.data.data.per_page,
                    norecord:true,
                    Loader:false
                })
            })
            .catch((error) => {
                this.setState({
                    norecord:true,
                    Loader:false
                })
            });
    }

    componentDidMount() {
        this.getBuyer();
    }

    render() {
        if (!this.state.user) {
            return <Redirect to="/signin" />;
        }

        return (
            <div className="admin">
                <Sidebar activePage="buyer" />
                <div class="content-area">
                 {this.state.Loader ? <div className="loader"> <Spinner type="grow" color="dark" style={{ width: '3rem', height: '3rem' }} /> </div> : ""}
                <Navbar activePage="property-listing"/>   
                    <div class="content">
                        <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <h2 id="page_headeing"><span>Buyer List</span></h2>
                                <div class="row align-items-end">
                                    <div class="col-6">
                                        <Input 
                                            type="text" 
                                            onChange={(e) => this.handleSearch(e)} 
                                            placeholder="Search"  
                                            className="form-control form-control_new border-0 border-end-0"
                                        />
                                    </div>
                                   
                                    </div>
                                </div>
                                <hr />
                                <div>
                                <div class="table-responsive">
                                    <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr class="border-bottom">
                                            <th style={{minWidth:70}}>Sr. No.</th>
                                            <th>Name</th>
                                            <th style={{minWidth:130}}>Email</th>
                                            <th>Country</th>
                                            <th style={{minWidth:120}}>Current plan</th>
                                            <th style={{minWidth:120}}>Created Date</th>                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.buyerList.length > 0 && this.state.buyerList.map((item, idx) => (
                                        <tr>
                                            <td>{idx+1}</td>
                                            <td>{item.fullName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.country_name}</td>
                                            <td>{item.current_plan}</td>
                                            <td>{dateFormat(item.created_at)}</td>
                                        </tr>
                                    ))}

                                    {this.state.buyerList.length === 0 && this.state.norecord==true && 
                                        <tr className="text-center">
                                            <td colspan="7">No record found</td>
                                        </tr>
                                    }
                                    </tbody>
                                    </table>
                                </div>
                                <div class="mt-4 text-center">
                                    {this.state.totalItemsCount>0 && 
                                        <div class="justify-content-center d-flex">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.totalItemsCount}
                                            pageRangeDisplayed={5}
                                            onChange={this.handlePageChange.bind(this)}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination justify-content-center"
                                            activeLinkClass="active"
                                            nextPageText="Next"
                                            prevPageText="Previous"
                                        />
                                        </div>
                                    }
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
}
}
